(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-alt"]) return;
  try {
    

  theme.HeaderSectionAlt = new function () {
    this.onSectionLoad = function (container) {
       this.$container = $(container);

       // set anything that alters based on contents/viewport/scroll, etc
       this.section = document.querySelector('.section-header');

       this.functions.setSticky.call(this);
       this.functions.setHeaderHeightProperty.call(this);
       this.functions.setScrollClass.call(this);

       $(window).on('scroll.headerSection', this.functions.afterScroll.bind(this));
       $(window).on('debouncedresize.headerSection', this.functions.afterResize.bind(this));

       // account / localization (after mobile nav initialises)
       $('.disclosure', container).each(function () {
         $(this).data('disclosure', new theme.Disclosure($(this)));
       });

       $('.mobile-navigation-drawer .disclosure').each(function () {
         $(this).data('disclosure', new theme.Disclosure($(this)));
       });

       // reveal cart drawer
       if (theme.settings.cart_type == 'drawer' && document.querySelector('.cart-drawer')) {
         $(container).on('click', '.cart-link', (evt) => {
           evt.preventDefault();
           document.dispatchEvent(
             new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false })
           );
         });
       }

       // listen to cart changes
       $(document).on('theme:cartchanged.headerSection', function () {
         $.getJSON(location.origin + '?sections=header-alt', function (data) {
           var cartSummarySelectors = ['#pageheader .header-alt-link.cart'];
           for (var i = 0; i < cartSummarySelectors.length; i++) {
             var $newCartObj = $('<div>' + data['header-alt'] + '</div>').find(cartSummarySelectors[i]).first();
             var $currCart = $(cartSummarySelectors[i]);
             $currCart.html($newCartObj.html());
           }
         });
       });

       // init mobile nav again if it's open and this is a reload
       if (Shopify.designMode && $('body').hasClass('reveal-mobile-nav')) {
         theme.openMobileNav();
       }

       // search
       if ($('.header-search-template', container).length) {
         $(container).on('click.headerSection', '.show-search-link', (evt) => {
           evt.preventDefault();
           evt.stopPropagation();

           if (document.querySelector('.header-search-content:not(.hidden)')) {
             this.functions.closeSearch.call(this);
           } else {
             this.functions.openSearch.call(this);
           }
         });
       }
     };

     this.onSectionUnload = function (container) {
       $(container).off('.headerSection');
       $(document).off('.headerSection');
       $(window).off('.headerSection');
       $('.disclosure', container).each(function () {
         $(this).data('disclosure').unload();
       });
       $('.mobile-navigation-drawer .disclosure').each(function () {
         $(this).data('disclosure').unload();
       });
       theme.Navigation.destroy($('.navigation', container));
     };


     this.onBlockSelect = function (container) {
       if(container.classList.contains('header-alt_megamenu'))
         document.body.classList.add('megamenu-active')
     }
    this.onBlockDeselect = function (container) {
       if(container.classList.contains('header-alt_megamenu'))
         document.body.classList.remove('megamenu-active')
     }


     this.functions = {
       afterScroll: function () {
         this.functions.setScrollClass.call(this);
       },

       afterResize: function () {
         this.functions.setSticky.call(this);
         this.functions.setHeaderHeightProperty.call(this);
       },

       setSticky: function () {
         this.isSticky = getComputedStyle(this.section).position === 'sticky' || getComputedStyle(this.section).position === '-webkit-sticky';
       },

       setHeaderHeightProperty: function () {
         var headerHeight = 0,
           stickyHeaderHeight = 0;
         if (this.section) {
           headerHeight = Math.ceil(this.section.clientHeight);
           if (this.isSticky) {
             stickyHeaderHeight = headerHeight;
           }
         }
         theme.enqueueStyleUpdate(() => {
           document.documentElement.style.setProperty('--theme-header-height', headerHeight + 'px');
           document.documentElement.style.setProperty('--theme-sticky-header-height', stickyHeaderHeight + 'px');
         });
       },

       setScrollClass: function () {
         const p = getComputedStyle(document.querySelector('.section-header')).position,
           ab = document.querySelector('.section-announcement-bar'),
           t = ab ? ab.offsetTop + ab.clientHeight : 0;

         theme.enqueueStyleUpdate(() => {
           document.body.classList.toggle('floating-header', /*p === 'sticky' && */window.scrollY > t);
         });
       },

     };
  }()
   theme.Sections.register('header-alt', theme.HeaderSectionAlt, { deferredLoad: false });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
          const container = document.querySelector('.prodcut__images-con');
          const mainSwiper = container.querySelector('.main-product-swiper')
          var gallerySwiper = null
          const options = document.querySelectorAll('.option-selector.option-selector--swatch .opt-btn');
          if(options.length == 0){
            mainSwiper.classList.add('active')
          }
          options.forEach(swatch => {
            const swatchNameEle = document.querySelector(`.opt-label[for="${swatch.id}"]`)
            if(container.querySelector(`.product__image[alt^="${swatchNameEle.innerText}"]`)){
              const newSwiper = mainSwiper.cloneNode(true);
              newSwiper.querySelector('.swiper-wrapper').innerHTML = null
              newSwiper.querySelector('.swiper-wrapper').append(...Array.from(container.querySelectorAll(`.product__image[alt^="${swatchNameEle.innerText}"]`)).map(ele => ele.closest(".swiper-slide")))
              newSwiper.setAttribute('data-swatch-anchor', swatchNameEle.innerText)
              container.append(newSwiper)
              if(swatch.checked){
                newSwiper.classList.add('active')
                document.querySelector('.prodcut__images-con').style.setProperty('--height', newSwiper.scrollHeight + 'px')
                
                if (window.matchMedia("(max-width: 767px)").matches) {
                  gallerySwiper = new Swiper(newSwiper, {
                    slidesPerView: 1,
                    navigation: {
                      nextEl: newSwiper.querySelector('.product-slider__nav.next'),
                      prevEl: newSwiper.querySelector('.product-slider__nav.prev'),
                    },
                     pagination: {
                      el: newSwiper.querySelector('.swiper-pagination'),
                      clickable: true,
                    },
                  });
                } 
              }
            }
          })
          if(!mainSwiper.querySelector('.swiper-wrapper').innerHTML)
            mainSwiper.remove()
          /*else{
            if (window.matchMedia("(max-width: 767px)").matches) {
              var gallerySwiper = new Swiper('.main-product-swiper', {
                slidesPerView: 1,
                navigation: {
                  nextEl: '.product-slider__nav.next',
                  prevEl: '.product-slider__nav.prev',
                },
                 pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
                },
              });
            } 
          }*/
        $(this).on('variantChanged', function (evt, variant) {
          // console.log(document.querySelector(".option-selector--swatch .opt-btn:checked").value)
          let swiperEle = document.querySelector(`.main-product-swiper[data-swatch-anchor="${document.querySelector(".option-selector--swatch .opt-btn:checked").value}"]`)
          let main = false
          if(!swiperEle){
            swiperEle = container.querySelector('.main-product-swiper')
            main = true
          }
          if(!swiperEle.classList.contains('active')){
            document.querySelector('.main-product-swiper.active')?.classList.remove('active')
            swiperEle.classList.add('active')
            //swiperEle.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            window.scrollTo({ top: 0, behavior: 'smooth' });
            
            document.querySelector('.prodcut__images-con').style.setProperty('--height', swiperEle.scrollHeight + 'px')
            
            if (window.matchMedia("(max-width: 767px)").matches && !swiperEle.classList.contains('swiper-initialized')) {
              gallerySwiper = new Swiper(swiperEle, {
                slidesPerView: 1,
                navigation: {
                  nextEl: swiperEle.querySelector('.product-slider__nav.next'),
                  prevEl: swiperEle.querySelector('.product-slider__nav.prev'),
                },
                 pagination: {
                  el: swiperEle.querySelector('.swiper-pagination'),
                  clickable: true,
                },
              });
            } 
          }
        })
          // $(document).on('variantImageSelected', '.gallery', (e, data, isFirstRun) => {
          //   let swiperEle = document.querySelector(`.main-product-swiper[data-swatch-anchor="${data.option1}"]`)
          //   let main = false
          //   if(!swiperEle){
          //     swiperEle = container.querySelector('.main-product-swiper')
          //     main = true
          //   }
          //   if(!swiperEle.classList.contains('active')){
          //     document.querySelector('.main-product-swiper.active')?.classList.remove('active')
          //     swiperEle.classList.add('active')
          //     //swiperEle.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          //     window.scrollTo({ top: 0, behavior: 'smooth' });
          //     document.querySelector('.prodcut__images-con').style.height = swiperEle.scrollHeight + 'px'
              
          //     if (window.matchMedia("(max-width: 767px)").matches && !swiperEle.classList.contains('swiper-initialized')) {
          //       gallerySwiper = new Swiper(swiperEle, {
          //         slidesPerView: 1,
          //         navigation: {
          //           nextEl: swiperEle.querySelector('.product-slider__nav.next'),
          //           prevEl: swiperEle.querySelector('.product-slider__nav.prev'),
          //         },
          //          pagination: {
          //           el: swiperEle.querySelector('.swiper-pagination'),
          //           clickable: true,
          //         },
          //       });
          //     } 
          //   }
            
          //   if(isFirstRun || !main) return
          //   const curr = document.querySelector(`.swiper-slide[data-media-id="${data.featured_media.id}"]`);
          //    if(curr){
          //       if (window.matchMedia("(max-width: 767px)").matches) {
          //         gallerySwiper.slideTo(Array.prototype.indexOf.call(curr.parentNode.children, curr));
          //       } else {
          //         curr.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          //       }
          //     }
          // }) 
             
           
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-meta"] && !Shopify.designMode) return;
  try {
    
    if (window.matchMedia("(max-width: 767px)").matches) {
      new Swiper('.product-details__swiper', {
        slidesPerView: 1.4,
        spaceBetween: 8,
      });
    } 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
